import { render, staticRenderFns } from "./HistorialMovimientos.vue?vue&type=template&id=437a1d3e"
import script from "./HistorialMovimientos.vue?vue&type=script&lang=js"
export * from "./HistorialMovimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports